import React from "react"
import styled from "styled-components"
import PropTypes from 'prop-types'
import MenuTitle from './menuTitle' 

const Container = styled.nav`
  background-color: transparent;
  padding-top: 15px;
  padding-bottom: 15px;
  /* display: none; */
  @media (min-width: 646px){
    display: initial;
  }

`
const Lista = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0;
`
const Item = styled.li`
  & + li {
      margin-top: 0.2em;
  }
  a {
    color: var(--cText);
    font-weight: 300;
    font-size: 0.87rem;
    &:hover,
    &:active {
      color: var(--cThird);
    }
  }
`

const MenuFooter = ({ data }) => (
 <Container>
   <MenuTitle title={data.title} />
   <Lista>
    {
      data.itens.map((item, key) => (
        <Item key={key} >
          <a {...item}>{item.title}</a>
        </Item>
      ))
    }
   </Lista>
  
 </Container>
)

MenuFooter.propTypes = {
  data: PropTypes.object.isRequired,
}
export default MenuFooter
